var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTablerChartInfographic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 4.66667C2.5 5.37391 2.78095 6.05219 3.28105 6.55229C3.78115 7.05238 4.45942 7.33333 5.16667 7.33333C5.87391 7.33333 6.55219 7.05238 7.05229 6.55229C7.55238 6.05219 7.83333 5.37391 7.83333 4.66667C7.83333 3.95942 7.55238 3.28115 7.05229 2.78105C6.55219 2.28095 5.87391 2 5.16667 2C4.45942 2 3.78115 2.28095 3.28105 2.78105C2.78095 3.28115 2.5 3.95942 2.5 4.66667Z",
    stroke: "#005996",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.16669 2V4.66667H7.83335M6.50002 11.3333V14M11.8334 9.33333V14M9.16669 8.66667V14M14.5 8V14",
    stroke: "#005996",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTablerChartInfographic);
export default __webpack_public_path__ + "static/media/tabler_chart-infographic.25a00eba2c24c541eabfee34cd59c14c.svg";
export { ForwardRef as ReactComponent };